import { axiosInstance } from '@/utils/axiosInstance';
import {
  IGetCepResponse,
  IGetUserLocationResponse,
  IUpdateUserLocationRequest,
} from './interfaces/user.interface';

export const UserService = {
  getCep: async (cep: string): Promise<IGetCepResponse> => {
    const cepRequest = {
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_SCORPION_ENDPOINT_URL}/api/correios?q=${cep}`,
    };

    const res = await axiosInstance(cepRequest);

    return res.data;
  },

  getUserLocation: async (
    authToken: string
  ): Promise<IGetUserLocationResponse> => {
    const locationRequest = {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/hal+json',
        'Accept-Version': '7',
      },
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_SCORPION_ENDPOINT_URL}/api/profiles/address/edit?auth_token=${authToken}`,
    };

    const res = await axiosInstance(locationRequest);

    return res.data;
  },

  updateUserLocation: async ({
    userId,
    radius,
    authToken,
    address_fields,
  }: IUpdateUserLocationRequest): Promise<void> => {
    const locationRequest = {
      headers: {
        Accept: 'application/json',
      },
      method: 'PATCH',
      url: `${process.env.NEXT_PUBLIC_SCORPION_ENDPOINT_URL}/api/profiles?auth_token=${authToken}`,
      data: {
        radius,
        address_fields,
      },
    };

    await axiosInstance(locationRequest);
  },
};
